<div class="content">
    <h1 class="mb-3">About</h1>
    kloppferski@gmail.com
</div>